import React from 'react';
import $ from 'jquery';
import { Dropdown } from 'react-bootstrap';

class BatchSelector extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            selectedBatch: null
        };
        this.batchChangeHandler = this.batchChangeHandler.bind(this);
    }

    batchChangeHandler(batchId) {
        // Find the selected batch object
        const selectedBatch = this.props.batches.find(batch => batch.id === batchId);
        this.setState({ selectedBatch });
        
        this.props.stateManagementService.updateBatchId(batchId).then(() => {
            this.props.batchChanged();
        }).catch(error => {
            console.error(error);
        });
    }

    render() {
        // Get the display text based on selected batch
        const toggleText = this.state.selectedBatch 
            ? (this.state.selectedBatch.debug 
                ? `Extraction ${this.props.currentExtraction?.id}; Debug Batch`
                : `Extraction ${this.props.currentExtraction?.id}; Full Crawl Batch: ${this.state.selectedBatch.id}`)
            : 'Select Batch';

        return (
            <Dropdown>
                <Dropdown.Toggle variant="light" id="dropdown-basic">
                    {toggleText}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {(this.props.batches ? this.props.batches : []).map(batch => {
                        if (batch.debug) {
                            return (
                                <React.Fragment key={batch.id}>
                                    <Dropdown.Item
                                        eventKey={batch.id}
                                        onClick={() => this.batchChangeHandler(batch.id)}
                                        style={{
                                            color: 'var(--bs-success)', // Success variant color
                                            transition: 'color 0.3s', // Smooth color transition
                                        }}
                                    >
                                        Extraction {this.props.currentExtraction?.id}; Debug Batch
                                    </Dropdown.Item>
                                    {/* Separator line */}
                                    <Dropdown.Divider />
                                </React.Fragment>
                            );
                        } else {
                            return (
                                <Dropdown.Item 
                                    key={batch.id} 
                                    onClick={() => this.batchChangeHandler(batch.id)}
                                >
                                    Extraction {this.props.currentExtraction?.id}; Full Crawl Batch: {batch.id}
                                </Dropdown.Item>
                            );
                        }
                    })}
                </Dropdown.Menu>
            </Dropdown>
        );
    }
}

export default BatchSelector;